import React from 'react';
import { Check, LockKeyhole } from 'lucide-react';

const STEPS = [
    { label: 'Demo-Session öffnen', detail: 'Geschützter Demo-Zugang wird eingerichtet.' },
    { label: 'Beispieldaten verbinden', detail: 'Umsatz, Bestand und Retouren werden geladen.' },
    { label: 'Dashboard vorbereiten', detail: 'Kennzahlen und Ansichten werden aufgebaut.' }
];

export default function DemoLoadingScreen({ currentStep }) {
    return (
        <div className="relative min-h-screen overflow-hidden bg-[#050A16] px-5 py-10 text-white">
            <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_50%_42%,rgba(21,36,67,0.42),transparent_38%),radial-gradient(circle_at_67%_72%,rgba(229,92,26,0.12),transparent_27%)]" />

            <div className="relative mx-auto flex min-h-[calc(100vh-5rem)] w-full max-w-3xl flex-col items-center justify-center">
                <img
                    src="/commetriq-logo-dark.webp"
                    alt="commetriq Logo"
                    className="mb-12 h-12 w-auto max-w-[250px] object-contain sm:h-14"
                />

                <section className="w-full rounded-lg border border-slate-700/80 bg-[#0A1222]/88 px-6 py-8 shadow-[0_28px_90px_rgba(0,0,0,0.38)] backdrop-blur sm:px-10 sm:py-10">
                    <div className="border-b border-slate-700/70 pb-7">
                        <p className="text-xs font-bold uppercase text-[#F16A27]">Demo-Zugang</p>
                        <h1 className="mt-3 text-2xl font-bold sm:text-4xl">Dashboard wird vorbereitet</h1>
                        <p className="mt-3 max-w-xl text-sm leading-6 text-slate-400 sm:text-base">
                            Wir laden einen Beispiel-Shop mit anonymisierten Daten und schreibgeschütztem Zugriff.
                        </p>
                    </div>

                    <div className="mt-7">
                        {STEPS.map(({ label, detail }, index) => {
                            const isComplete = index < currentStep;
                            const isActive = index === currentStep;

                            return (
                                <div key={label} className="relative flex min-h-[76px] gap-5 last:min-h-0">
                                    {index < STEPS.length - 1 && (
                                        <span className={`absolute left-[9px] top-6 h-[52px] w-px ${isComplete ? 'bg-[#F16A27]' : 'bg-slate-700'}`} />
                                    )}
                                    <span className={`relative z-10 mt-1 flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors duration-300 ${
                                        isComplete
                                            ? 'border-[#F16A27] bg-[#F16A27] text-white'
                                            : isActive
                                                ? 'border-[#F16A27] bg-[#F16A27]/15 shadow-[0_0_18px_rgba(241,106,39,0.7)]'
                                                : 'border-slate-600 bg-[#0A1222]'
                                    }`}>
                                        {isComplete && <Check className="h-3 w-3" strokeWidth={3} />}
                                        {isActive && <span className="h-2 w-2 animate-pulse rounded-full bg-[#F16A27]" />}
                                    </span>
                                    <div className="min-w-0 pb-5">
                                        <div className={`text-base font-semibold transition-colors duration-300 ${isActive || isComplete ? 'text-white' : 'text-slate-500'}`}>
                                            {label}
                                        </div>
                                        <div className={`mt-1 text-sm ${isActive ? 'text-slate-400' : 'text-slate-600'}`}>
                                            {detail}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </section>

                <div className="mt-8 flex items-center gap-2 text-xs font-semibold uppercase text-slate-500">
                    <LockKeyhole className="h-4 w-4" />
                    Kein Login erforderlich
                </div>
            </div>
        </div>
    );
}
